import { globalSetup } from '@/scripts/core/global';

globalSetup()
